<template>
	<g>
		<rect :fill="style.lineColor"
			  :x="style.padding" :y="height - style.padding * 2 - style.legendHeight"
			  :width="width - style.padding * 2" :height="style.lineWidth"></rect>

		<g v-for="index in (bins + 1)" :key="index">
			<template v-if="index%binInterval == 0">
				<circle :cx="centerScaleX(index)"
					:cy="legendStart"
					:r="style.lineWidth * 3"
					:fill="style.legendColor">
				</circle>
				<text	:x="centerScaleX(index)"
						:y="legendStart + 20"
						:style="legendFont === 'regular' ? style.legendFont : style.smallLegendFont"
						text-anchor="middle">
						{{ formatDate(binDate(index)) }}
				</text>
				<text	:x="centerScaleX(index)"
						:y="legendStart + 35"
						:style="legendFont === 'regular' ? style.legendFont : style.smallLegendFont"
						text-anchor="middle">
						{{ days[binDate(index).getDay()] }}
				</text>
				<rect   :fill="style.lineColor"
						:x="centerScaleX(index)" :y="style.padding"
						:width="style.lineWidth" :height="height - style.padding * (scaleZero ? 3 : 4) - style.legendHeight">
				</rect>
			</template>
			
		</g>
	</g>
</template>

<script>
import style from '../config/style'

const oneDay = 86400000
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

import formatDate from '../util/format-date'

export default {
	name: 'graph-legend',

	props: {
		/**
		 * @prop 	startDate
		 * @type 	Date
		 * @desc	Starting date of the date picker
		 * @required
		 */
	    startDate: {
	        type: Date,
	        required: true
		},
		
		/**
		 * @prop 	bins
		 * @type 	Number
		 * @desc	Number of bins (x axis point) required
		 * @required
		 */
		bins: {
			type: Number,
			required: true
		},

		/**
		 * @prop 	bins
		 * @type 	Number
		 * @desc	Number of bins (x-axis points) required
		 */
	    binWidth: {
	        type: Number,
			default: 1,
		},
		
		/**
		 * @prop 	width
		 * @type 	Number
		 * @desc	Width of the SVG
		 * @required
		 */
	    width: {
	        type: Number,
			default: 1000,
		},
		
		/**
		 * @prop 	width
		 * @type 	Number
		 * @desc	Width of the SVG
		 */
	    height: {
	        type: Number,
	        default: 200
		},
		
		/**
		 * @prop  	binInterval
		 * @type 	Number
		 * @desc	Interval between successive bin on legend 
		 */
		binInterval: {
			type: Number,
			default: 1
		},
		/**
		 * @prop  	verticalScale
		 * @type 	Number
		 * @desc	Interval between successive bin on legend 
		 */
		scaleZero: {
			type: Boolean,
			default: false
		},
		/**
		 * @prop  	legendFont
		 * @type 	String
		 * @desc	Styling of the font
		 */
		legendFont: {
			type: String,
			default: "regular"
		},
	},

	data() {
		return {
			days,
			style
		}
	},

	computed: {
		/**
		 * @function 	legendStart
		 * @desc		vertical distance at which x-axis points are plotted
		 */
		legendStart() {
			return this.height - this.style.padding * 2 - this.style.legendHeight
		},

		/**
		 * @function 	gridLines
		 * @desc		number of lines to be plotted (on which values will be plotted)
		 */
		gridLines() {
			return this.bins + 1
		}
	},

	methods: {
		formatDate,
		centerScaleX(x) {
			return (x - 0.5) * this.width / this.gridLines
		},
		binDate(index) {
			return new Date(this.startDate.getTime() + this.binWidth * oneDay * (index - 1))
		}
	}
}
</script>
